import {z} from 'zod';

import {advertisementPayloadSchema} from './AdvertisementPayloadSchema';
import {
  advertisingCredentialsSchema,
  advertisingImageSchema,
  advertisingPlatformCodeSchema,
} from './AdvertisingCommonSchemas';

export const enqueueAdvertisementRequestSchema = z.object({
  tenantId: z.string().uuid(),
  vehicleId: z.string().uuid(),
  platformCode: advertisingPlatformCodeSchema,
  publishingBranchId: z.string().uuid().nullable(),
  vehicle: advertisementPayloadSchema,
  images: z.array(advertisingImageSchema).default([]),
  credentials: advertisingCredentialsSchema.nullable(),
});

export type EnqueueAdvertisementRequest = z.infer<typeof enqueueAdvertisementRequestSchema>;
